import React from "react";
import PropTypes from "prop-types";

import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import {toggleArrayValue} from "../../../FeatureCreator/FeaturesFilters/filtersFunctions";
import CheckBox from "../../../PageLayout/CheckBox";

const WizardPopupFiltersExclusionFilter = (props) => {

  const {filter} = props;

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);
  const {filtersExcluded} = wizardPopupState;

  const toggleExcluded = () => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        filtersExcluded: [...toggleArrayValue(filtersExcluded, filter.id)]
      }
    })
  }

  return (
    <li className="fc-filters__list-item">
      <CheckBox type="tiny"
                checked={!filtersExcluded.includes(filter.id)}
                text={filter.displayText}
                onChecked={toggleExcluded} />
    </li>
  )
};

WizardPopupFiltersExclusionFilter.propTypes = {
  filter: PropTypes.object.isRequired
}

export default WizardPopupFiltersExclusionFilter
